/**
 * BT HSA/FSA banner — Learn more dialog.
 */
class BtHsaBanner extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-bt-hsa-open]')?.addEventListener('click', this.#open);
    this.querySelector('[data-bt-hsa-backdrop]')?.addEventListener('click', this.#onBackdropClick);
    this.querySelectorAll('[data-bt-hsa-close]').forEach((el) => {
      el.addEventListener('click', this.#close);
    });
    this.querySelector('[data-bt-hsa-dialog]')?.addEventListener('cancel', this.#onCancel);
  }

  disconnectedCallback() {
    this.querySelector('[data-bt-hsa-open]')?.removeEventListener('click', this.#open);
    this.querySelector('[data-bt-hsa-backdrop]')?.removeEventListener('click', this.#onBackdropClick);
    this.querySelectorAll('[data-bt-hsa-close]').forEach((el) => {
      el.removeEventListener('click', this.#close);
    });
    this.querySelector('[data-bt-hsa-dialog]')?.removeEventListener('cancel', this.#onCancel);
  }

  #dialog() {
    return this.querySelector('[data-bt-hsa-dialog]');
  }

  #open = () => {
    const dialog = this.#dialog();
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('bt-hsa-banner-open');
  };

  #close = () => {
    const dialog = this.#dialog();
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('bt-hsa-banner-open');
  };

  #onBackdropClick = (event) => {
    if (event.target === event.currentTarget) this.#close();
  };

  #onCancel = (event) => {
    event.preventDefault();
    this.#close();
  };
}

if (!customElements.get('bt-hsa-banner')) {
  customElements.define('bt-hsa-banner', BtHsaBanner);
}
